import { connect } from 'react-redux';
import { DefaultButton, FontIcon, FontSizes, Label, Link, Separator } from '@fluentui/react';
import { useEffect, useState } from 'react';
import MOMENT from 'react-moment';
import { Text, Toast, ToastBody, Toaster, ToastFooter, ToastPosition, ToastTitle, useToastController } from '@fluentui/react-components';
import { List, ListItem } from "@fluentui/react-migration-v0-v9";

//functions
import * as ComponentFunctions from './SettlementHeader.Functions';

////i18Next
import { useTranslation, Trans } from 'react-i18next';

// components 
import SettlementChangeStatusConfirmationFormComponent from '../SettlementChangeStatusConfirmationForm/SettlementChangeStatusConfirmation.Form.Component';

// Styles
import './SettlementHeader.Styles.css';
import { SettlementStatusEnum } from '../../../models/Enums/SettlementStatusEnum';
import SettlementDebtsDetailsComponent from '../SettllementDebtsDetails/SettlementDebtsDetails.Component';

export const SettlementHeaderComponent = (props: ComponentFunctions.Props) => {

    const [Today, setToday] = useState<Date>(new Date());
    const EditContract = () => { };
    const AssociateProtocol = () => { };

    const { t } = useTranslation()

    const { dispatchToast } = useToastController('SettlementToast');
    const [position, setPosition] = useState<ToastPosition>("bottom-end");
    const [timeout, setDismissTimeout] = useState<number>(5000);

    useEffect(() => {
        props.GetSettlementById(props.SettlementId);
    }, []);

    useEffect(() => {
        if (props.failOnChangeStatus === true) {
            dispatchToast(
                <Toast appearance="inverted" className='Toast LeftBorder red'>
                    <ToastTitle>{'Error al confirmar la liquidación'}</ToastTitle>
                    <ToastBody>
                        {props.error?.ErrorMessage}
                        <Separator />
                        <List>
                            {props.error?.Errors?.map((error: string) => (
                                <ListItem>
                                    {error}
                                </ListItem>
                            ))}
                        </List>
                    </ToastBody>
                </Toast>,
                { timeout, position, intent: "error" }
            );
        }
    }, [props.failOnChangeStatus]);

    useEffect(() => {
        if (props.changeStatusSuccessfully) {
            props.GetSettlementById(props.SettlementId);
            props.ResetSettlementChangeStatusFlags(props.SettlementId);
        }
    }, [props.changeStatusSuccessfully]);

    useEffect(() => {
        if (props.Settlement) {
            props.Settlement?.protocol[0]?.protocolId && props.GetMedicalProtocolById(props.Settlement?.protocol[0]?.protocolId);
            props.Settlement?.contract[0]?.contractId && props.GetContractById(props.Settlement?.contract[0]?.contractId);
        }
    }, [props.Settlement?.protocol[0]?.protocolId, props.Settlement?.contract[0]?.contractId]);

    const Controls = (
        <>
            {props.Settlement?.status === SettlementStatusEnum.FINISHED &&
                <>
                    <SettlementChangeStatusConfirmationFormComponent SettlementId={props.SettlementId} NextStatusIsActionConfirmed={SettlementStatusEnum.CONFIRMED} />
                    <SettlementChangeStatusConfirmationFormComponent SettlementId={props.SettlementId} NextStatusIsActionConfirmed={SettlementStatusEnum.CANCELLED} />
                </>
            }
            {props.Settlement?.status === SettlementStatusEnum.CONFIRMED &&
                <>
                    <SettlementChangeStatusConfirmationFormComponent SettlementId={props.SettlementId} NextStatusIsActionConfirmed={SettlementStatusEnum.CANCELLED} />
                </>
            }
            <Toaster toasterId={'SettlementToast'} />
        </>
    );


    return (
        <>
            <div className={"Section"}>
                <div className="ContractHeader">
                    {props.Settlement?.status === SettlementStatusEnum.PAID && (
                        <div className="WatermarkPaid">{t('SettlementStatus.paid')}</div>
                    )}
                    <div className="ContractHeader_Title">
                        <div>
                            <h3>{props.Settlement?.name}</h3>
                            <Label>{props.Settlement?.description}</Label>
                        </div>
                        <div className='ComponentControls'>
                            {Controls}
                        </div>
                    </div>
                    <Separator />
                    <div className='ContractHeaderDetails'>
                        <div>
                            <small>{t('settlementHeader.contractHeaderDetails.status')}</small>
                            <Label className='ContentAlignedHorizontally'><FontIcon className={props.Settlement?.status === 2 ? 'withRotation' : ''} iconName={ComponentFunctions.GetSettlementStatusIcon(props.Settlement?.status)} style={{ fontSize: FontSizes.size16 }} />&nbsp;<strong>{t(ComponentFunctions.GetSettlementStatusDescripcion(props.Settlement?.status))}</strong></Label>
                        </div>
                        <div>
                            <small>{t('settlementHeader.contractHeaderDetails.currency')}</small>
                            <Label><strong>{props.Settlement?.currencyCode}</strong></Label>
                        </div>
                        <div>
                            <small>{t('settlementHeader.contractHeaderDetails.identifier')}</small>
                            <Label><strong>{props.Settlement?.identifier}</strong></Label>
                        </div>
                        {props.Settlement?.status === 5 && <div>
                            <small>Factura</small>
                            <Label><strong>{props.Settlement?.voucheredNumber}</strong></Label>
                        </div>}
                        {props.Settlement?.status === 5 && props.Settlement?.bussinessname && <div>
                            <small>Razón Social</small>
                            <Label><strong>{props.Settlement?.bussinessname}</strong></Label>
                        </div>}

                    </div>
                    {(props.Settlement?.status === SettlementStatusEnum.CONFIRMED || props.Settlement?.status === SettlementStatusEnum.PAID) &&
                        <div>
                            <SettlementDebtsDetailsComponent SettlementId={props.SettlementId} />
                        </div>
                    }
                </div>
            </div>
        </>
    );

}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(SettlementHeaderComponent as any);